import { render, staticRenderFns } from "./DropdownInfos.vue?vue&type=template&id=19f95d08&"
import script from "./DropdownInfos.vue?vue&type=script&lang=js&"
export * from "./DropdownInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports